/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import KpiCard from "../../components/KpiCard/KpiCard";

import styled from "styled-components";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import DistribuidoresDesktop from "./components/DistribuidoresDesktop";
import CargosDesktop from "./components/CargosDesktop";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function OverviewDesktop({ app, config }) {
  const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });

  const [selectedValueCargo, setSelectedValueCargo] = useState("Gerente Geral");
  const [toggleScreen, setToggleScreen] = useState("Distri");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const cargos = selections.length
        ? selections.find((s) => s.qField === "Tipo_Analise")
        : null;
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_Pasta")
        : null;

      setSelectedValueCargo(cargos?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const handleChange = (event) => {
    app.field("Tipo_Analise").selectMatch(event.target.value, true);
    setSelectedValueCargo(event.target.value);
  };

  return (
    <div className="app overview">
      <div className="appContent">
        <div className="container-links-overview">
          <button onClick={() => setToggleScreen("Distri")} style={{ textDecoration: toggleScreen === 'Distri' ? "underline" : 'none' }} >
            Distribuidores
          </button>

          <button  onClick={() => setToggleScreen("Cargos")} style={{ textDecoration: toggleScreen === 'Cargos' ? "underline" : 'none' }} >Cargos</button>
        </div>

        {
          toggleScreen === "Distri" && <DistribuidoresDesktop app={app} config={config} />
        }

        {
          toggleScreen === "Cargos" && <CargosDesktop  app={app} config={config} />
        }


      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
